$(document).ready(function () {
  /* init Jarallax */
  jarallax(document.querySelectorAll(".jarallax"));
  
// Open external link in new tab
  function externalLinks() {
    for(var c = document.getElementsByTagName("a"), a = 0;a < c.length;a++) {
      var b = c[a];
      b.getAttribute("href") && b.hostname !== location.hostname && (b.target = "_blank")
    }
  };
  externalLinks();

  var flkty = $('.cstm_banner_slider').flickity();

   // Custom button click handlers
   $('.custom-prev-button').on('click', function() {
      flkty.flickity('previous');
   });

   $('.custom-next-button').on('click', function() {
      flkty.flickity('next');
   });

  // artcle slider arrows js
  if(document.querySelector("[slider-component-desktop]")){
    const slider = document.querySelector("[slider-component-desktop]");
    const track = slider.querySelector("[data-slider-track]");
    const prev = slider.querySelector("[data-slider-prev]");
    const next = slider.querySelector("[data-slider-next]");
  
    if (track) {
      prev.addEventListener("click", () => {
        next.removeAttribute("disabled");
    
        track.scrollTo({
          left: track.scrollLeft - track.firstElementChild.offsetWidth,
          behavior: "smooth"
        });
      });
    
      next.addEventListener("click", () => {
        prev.removeAttribute("disabled");
    
        track.scrollTo({
          left: track.scrollLeft + track.firstElementChild.offsetWidth,
          behavior: "smooth"
        });
      });
    
      track.addEventListener("scroll", () => {
        const trackScrollWidth = track.scrollWidth;
        const trackOuterWidth = track.clientWidth;
    
        prev.removeAttribute("disabled");
        next.removeAttribute("disabled");
    
        if (track.scrollLeft <= 0) {
          prev.setAttribute("disabled", "");
        }
    
        if (track.scrollLeft === trackScrollWidth - trackOuterWidth) {
          next.setAttribute("disabled", "");
        }
      });
    }
  }
  
  $('.testimonails_slide').slick({
  infinite: false,
  slidesToShow: 2,
  slidesToScroll: 1,
  // centerMode: true,
  // centerPadding: '20px',
  arrows: true,
  prevArrow:'<button type="button" class="slick-arrow slick-prev"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"> <path fill="transparent" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M22.5 12.5 15 20l7.5 7.5"></path></svg> </button>',
  nextArrow:'<button type="button" class="slick-arrow slick-next"><svg xmlns="http://www.w3.org/2000/svg" width="40" height="40"><path d="M17.5 12.5 25 20l-7.5 7.5" fill="transparent" stroke-width="2" stroke="hsl(0, 0%, 100%)" stroke-linecap="round" stroke-linejoin="round"></path></svg></button>',
  responsive: [
    {
      breakpoint: 575,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 400,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
      }
    }
  ]

});
  
$('.slide_show').slick({
  dots: true,
  infinite: false,
  speed: 300,
  slidesToShow: 1,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    },
    {
      breakpoint: 480,
      settings: {
        slidesToShow: 1,
        slidesToScroll: 1
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  
// $(window).resize(function () {
  if ($(window).width() < 749) {
    var sourceDiv = $("#countdown-timer");
    var targetDiv = $(".mobile_view-count");
    sourceDiv.detach().appendTo(targetDiv);
  }else{
    var sourceDiv = $("#countdown-timer");
    var targetDiv = $(".desktop_view_count");
    sourceDiv.detach().appendTo(targetDiv);
  }
// });

  // itg blog page js
  $(document).on('click', '.blog__filter-top-content', function(){
    $(this).closest('.filter__option-label').find('.filter__complete-options').slideToggle();
    $(this).find('.blog__filter-options').slideToggle();
    
     if ($(this).find('span.blog-down-arrow svg').hasClass('rotated')) {
        $(this).find('span.blog-down-arrow svg').css('transform', 'rotate(0deg)');
        $(this).find('span.blog-down-arrow svg').removeClass('rotated');
    } else {
        $(this).find('span.blog-down-arrow svg').css('transform', 'rotate(180deg)');
        $(this).find('span.blog-down-arrow svg').addClass('rotated');
    }
  });
  $(document).on('click', 'span.filter__select-option', function(){
    $(this).closest('.filter__complete-options').find('.blog__filter-options').slideToggle();

    if ($(this).find('span.blog-down-arrow svg').hasClass('rotated')) {
        $(this).find('span.blog-down-arrow svg').css('transform', 'rotate(0deg)');
        $(this).find('span.blog-down-arrow svg').removeClass('rotated');
    } else {
        $(this).find('span.blog-down-arrow svg').css('transform', 'rotate(180deg)');
        $(this).find('span.blog-down-arrow svg').addClass('rotated');
    }
    
    // $(this).find('span.blog-down-arrow svg').css('rotate', '180deg');
  });
  $(document).on('click', '.blog__filter-top-content', function(){
    $(this).closest('.filter__option-label').find('.blog__filter-choose-option-02').slideToggle();
  });
  $(document).on('click', '.blog__filter-search', function(){
    $('summary.header__icon.header__icon--search').trigger('click');
  });

  if($(window).width() < 750){
    $(document).on('click', '.blog__filter-search', function(){
      $('.blog__filter-for-mb-popup').removeClass('active__sibe-popup');
      $('body').css('overflow','visible');
    });
  }
  $(document).on('click', '.blog__filter-left-sidebar-mb', function(){
    if(!($('.blog__filter-for-mb-popup').hasClass('active__sibe-popup'))){
      $('.blog__filter-for-mb-popup').addClass('active__sibe-popup');
      $('body').css('overflow','hidden');
    }
  });
  $(document).mouseup(function(e) {
    if($('.blog__filter-for-mb').length){
      var container = $('.blog__filter-for-mb');
      if (!container.is(e.target) && container.has(e.target).length === 0)
      { 
        $('.blog__filter-for-mb-popup').removeClass('active__sibe-popup');
        $('body').css('overflow','visible');
      }
    }
  });
  $(document).on('click','.blog-filter-cls',function(){
      $('.blog__filter-for-mb-popup').removeClass('active__sibe-popup');
      $('body').css('overflow','visible');
  })
});



// js for re-captcha of corporate page
async function checkCapcha() {
    let checkCaptcha = await addRecaptchaData();
    if(checkCaptcha){
      const Cpbutton = document.querySelector('.captcha_main_wrapper+div.needsclick.kl-private-reset-css-Xuajs1>button.needsclick');
      if (Cpbutton) {
          Cpbutton.setAttribute("disabled", "disabled");
      }
      let captcha;
      generate();
      var gen_func_call = document.querySelector(".captch_gen");
      if(gen_func_call){
        gen_func_call.addEventListener('click', function (){
          generate();
        }); 
      }
      var printmsg_func_call = document.querySelector(".captch_btn_submit");
      if(printmsg_func_call){
        printmsg_func_call.addEventListener('click', function (){
          printmsg();
        });
      }
      const inputs = document.querySelectorAll('.custom-corporate-form-wrapper input.needsclick, .competition-form-klaviyo-wrapper input.needsclick, .detail-form-klaviyo-wrapper input.needsclick,.custom-contact-form-wrapper input.needsclick');
      inputs.forEach((input, index) => {
          input.addEventListener('input', function() {
              if (input.value.trim() !== "") {
                  document.querySelector('.custom-corporate-form-wrapper, .competition-form-klaviyo-wrapper, .detail-form-klaviyo-wrapper, .custom-contact-form-wrapper').classList.remove('captcha_hide');
                document.querySelector('.captcha_main_wrapper+div.needsclick.kl-private-reset-css-Xuajs1>button.needsclick').setAttribute("disabled", "disabled");
              } 
          });
      });
      function generate() {
        // Clear old input
        if(document.querySelector("input.captch_submit")){
          var InputVal = document.querySelector("input.captch_submit");
          if(InputVal){
            InputVal.value = "";
          }
        }
        // Access the element to store the generated captcha
        captcha = document.querySelector(".captcha_image");
        let uniquechar = "";
        const randomchar = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
        // Generate captcha of length 5 with random characters
        for (let i = 1; i < 5; i++) {
          uniquechar += randomchar.charAt(Math.random() * randomchar.length);
        }
        // Store generated input
        if(captcha){
           captcha.innerHTML = uniquechar;
        }
      }
      function printmsg() {
        const usr_input = document.querySelector(".captch_submit").value;
        // Check whether the input matches the generated captcha
        if (usr_input == captcha.innerHTML) {
          document.querySelector(".captcha_key").innerHTML = "Success";
          document.querySelector(".captcha_key").style.color = "green";
          generate();
          // document.querySelector('button.go3176017753.kl-private-reset-css-Xuajs1').removeAttribute("disabled");
          // document.querySelector('button.needsclick.go4074735680.kl-private-reset-css-Xuajs1').removeAttribute("disabled");
          document.querySelector('.captcha_main_wrapper+div.needsclick.kl-private-reset-css-Xuajs1>button.needsclick').removeAttribute("disabled", "disabled");
          // document.querySelector('.recaptch_wrapper').style.display = 'none';
          document.querySelector('.custom-corporate-form-wrapper, .competition-form-klaviyo-wrapper, .detail-form-klaviyo-wrapper,.custom-contact-form-wrapper').classList.add("captcha_hide");
        } else {
          document.querySelector(".captcha_key").innerHTML = "not Matched";
          document.querySelector(".captcha_key").style.color = 'red';
          generate();
        }
      }
    }
  }
let captchaTimer = setInterval(()=>{
  checkCapcha();
},100);

function addRecaptchaData() {
      var captchaData = `<div class="captcha_main_wrapper"><div class="recaptch_wrapper"><div class="recaptcha_img_wrap"><div class="captcha_image" selectable="False"></div><div class="captch_gen"><img scr="https://cdn.shopify.com/s/files/1/0640/8254/2786/files/sync.png?v=1722862512" alt=""></div></div><div class="inline_box_wrapper"><div class="user_input"><label>Type The Word Above</label><input placeholder="Captcha code" type="text" class="captch_submit"></div><div class="action_btn_wrap"><div class="captcha_key" style="display: none;"></div><div class="captch_btn_submit">Verify</div></div></div></div></div>`;
      // js for corporate page, append recatcha
      if(document.querySelector('.custom-corporate-form-wrapper .klaviyo-form-version-cid_1')){
        $('.custom-corporate-form-wrapper form>.needsclick.kl-private-reset-css-Xuajs1 .needsclick[data-testid="form-row"]:nth-child(6)').prepend(captchaData);
      }
      
      // js for competition page, append recatcha
      if(document.querySelector('.competition-form-klaviyo-wrapper .klaviyo-form-version-cid_1')){
        $('.competition-form-klaviyo-wrapper form>.needsclick.kl-private-reset-css-Xuajs1 .needsclick[data-testid="form-row"]:nth-child(8)').prepend(captchaData);
      }
      
      // js for smoke page, append recatcha
      if(document.querySelector('.detail-form-klaviyo-wrapper .klaviyo-form-version-cid_1')){
        $('.detail-form-klaviyo-wrapper form>.needsclick.kl-private-reset-css-Xuajs1 .needsclick[data-testid="form-row"]:nth-child(6)').prepend(captchaData);
      }
      
      // js for contact page, append recatcha
      if(document.querySelector('.custom-contact-form-wrapper .klaviyo-form')){
          $('.custom-contact-form-wrapper form>.needsclick.kl-private-reset-css-Xuajs1 .needsclick[data-testid="form-row"]:nth-child(5)').prepend(captchaData);
      }
      if($('.captcha_main_wrapper').length){
         clearInterval(captchaTimer);
        return true;
      }
}



/* new header js */
window.onload = function () {
  const header = document.querySelector(".header");
  if (header) {
    header.style.visibility = "visible";
  }
};
